<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="800px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>fab fa-black-tie</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Register a new broker</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text class="pa-0">
        <v-stepper vertical v-model="step">
          <v-stepper-step step="1" :complete="step > 1" editable class="ma-0">
            Broker Details
            <small>The business details of the broker</small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card flat tile class="ma-0">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field label="Broker name" v-model="broker.name" required></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-switch label="Website" v-model="broker.branded"></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-switch label="Enabled" v-model="broker.enabled"></v-switch>
                          </v-flex>
                          <v-flex xs12 v-if="broker.branded">
                            <v-text-field label="Subdomain" v-model="broker.subdomain" required></v-text-field>
                          </v-flex>
                          <v-flex xs12 v-if="broker.branded">
                            <v-text-field
                              label="Landing Page Header"
                              v-model="broker.web_site_header"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 v-if="broker.branded">
                            <v-text-field
                              label="Landing Page Strap Line"
                              v-model="broker.web_strapline"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="step = 2" :disabled="stepOneInvalid">Continue</v-btn>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step > 2" editable>
            Logo
            <small>The main logo for the broker</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12>
                            <image-upload :url.sync="broker.logo" :path="'broker-images'"></image-upload>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="step = 3">Continue</v-btn>
          </v-stepper-content>

          <v-stepper-step step="3" :complete="step > 3" editable :rules="[() => !RegistrationEmailExists]">
            User
            <small v-if="RegistrationEmailExists">Email address is already registered</small>
            <small v-else>The primary user for the account</small>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs6>
                            <v-text-field label="First name" v-model="broker.user.firstName" required></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field label="Last name" v-model="broker.user.lastName" required></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              label="Email"
                              v-model="verifiedEmail"
                              :rules="emailRules"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field label="Phone" v-model="broker.user.phone" required></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="register" :disabled="stepThreeInvalid">Register</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import ImageUpload from '../Partners/ImageUpload';
import { emailRegex, emailRules } from '@/utils/validators';

export default {
  components: { ImageUpload },
  name: 'new-broker-dialog',
  props: ['show'],
  data: () => ({
    step: 1,
    broker: {
      name: null,
      subdomain: null,
      branded: false,
      enabled: false,
      logo: null,
      web_site_header: "<span class='huge'>Find <strong>funding</strong></span><br>for your business",
      web_strapline: 'Search for business funding now (it takes just a few minutes!)',
      user: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      }
    },
    emailRules
  }),
  computed: {
    ...mapGetters(['SelectedBroker', 'RegistrationEmailExists']),
    stepOneInvalid: function() {
      return _.isNull(this.broker.name);
    },
    stepThreeInvalid: function() {
      return (
        this.RegistrationEmailExists ||
        _.isNull(this.broker.user.firstName) ||
        _.isNull(this.broker.user.lastName) ||
        _.isNull(this.verifiedEmail) ||
        !emailRegex.test(this.verifiedEmail)
      );
    },
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    verifiedEmail: {
      get() {
        return this.broker.user.email;
      },
      set: _.debounce(function(email) {
        this.broker.user.email = email;
        this.verifyRegistrationEmail(email);
      }, 500)
    }
  },
  methods: {
    ...mapActions(['registerBroker', 'verifyRegistrationEmail']),
    clearRegistration() {
      this.broker = {
        name: null,
        subdomain: null,
        branded: false,
        enabled: false,
        logo: null,
        web_site_header: "<span class='huge'>Find <strong>funding</strong></span><br>for your business",
        web_strapline: 'Search for business funding now (it takes just a few minutes!)',
        user: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null
        }
      };
    },
    register() {
      this.registerBroker(this.broker).then(this.closeDialog());
    },
    closeDialog() {
      this.clearRegistration();
      this.dialog = false;
    },
    startCase: function(str) {
      str = _.lowerCase(str);
      return _.startCase(str);
    },
    isDefined: function(value) {
      return _.isUndefined(value) === false;
    },
    isFilled: function(value) {
      return !_.isEmpty(value);
    }
  },
  watch: {
    show: function() {
      this.step = 1;
      this.clearRegistration();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
